/**
 * Application Configuration
 * Central configuration file for environment variables and app settings
 */

export const config = {
  // API Configuration
  api: {
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000', 10),
  },

  // App Configuration
  app: {
    name: import.meta.env.VITE_APP_NAME || 'VastuSindu',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    environment: import.meta.env.MODE,
  },

  // Feature Flags
  features: {
    enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
  },

  // OAuth Configuration
  oauth: {
    google: {
      clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
    },
    facebook: {
      appId: import.meta.env.VITE_FACEBOOK_APP_ID || '',
    },
  },

  // Storage Keys
  storage: {
    accessToken: 'vastusindu_access_token',
    refreshToken: 'vastusindu_refresh_token',
    user: 'vastusindu_user',
  },
};

export default config;
